const periodOptions = ['LAST TWO WEEKS', 'FIRST TWO WEEKS', 'MONTHLY OFFER']

// function isUPCValid (upc) {
//   console.log(/\d{12,12}/, upc, /\d{12,12}/.test(upc))
//   return (/\d{12,12}/.test(upc))
// }

function isAllNumeric (expectedNumber) {
  return !isNaN(Number(expectedNumber)) && expectedNumber !== ''
}

function hasNoAlphabets (expectedAlphabetString) {
  return (expectedAlphabetString && expectedAlphabetString.length > 0)
}

function isPeriodInPeriodOptions (periodOptions, selectedOption) {
  return periodOptions.indexOf(selectedOption) > -1
}

function validateOffer (offer) {
  let error = {}

  // if (!isUPCValid(offer.upc)) error.upc = 'The UPC you are trying to edit is invalid'
  if (!isAllNumeric(offer.offInvoiceDiscount)) error.offInvoiceDiscount = 'The Off Invoice Discount Amount can only be numeric and non empty.'
  if (!isAllNumeric(offer.scanBackDiscount)) error.scanBackDiscount = 'The Scan Back Discount Amount can only be numeric and non empty.'
  if (!isAllNumeric(offer.suggestedRetailSavings)) error.suggestedRetailSavings = 'The Suggested Retail Savings can only be numeric and non empty.'
  if (!isPeriodInPeriodOptions(periodOptions, offer.period)) error.periodOptions = 'You can only choose between "LAST TWO WEEKS" or "FIRST TWO WEEKS" for editing a period.'
  if (!hasNoAlphabets(offer.offerName)) error.offerName = 'Offer name must not be empty.'
  return Object.keys(error).length > 0
    ? error
    : false
}

export function validate (offers) {
  let errorsInOffers = offers.map(validateOffer)
  let errorCount = 0
  for (let offerIndex = 0; offerIndex < errorsInOffers.length; offerIndex++) {
    if (errorsInOffers[offerIndex]) errorCount = errorCount + 1
  }
  return (errorCount === 0) ? false : errorsInOffers
}



// WEBPACK FOOTER //
// ./src/Services/Validation/submittedOffersEditValidator.js